import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm, Field, getFormValues } from 'redux-form';
import { Grid, Form, Icon, Message } from 'semantic-ui-react';

import { SecurityPreferences } from 'Common/Security/SecurityPreferences';
import { PreferencesEnum as PrefEnum } from 'Common/Security/PreferencesEnum';
import { InputField, SelectField, NumericField } from 'Common/SemanticWrapper';
import { CHARGE_PERMISSION_FORM_NAME, InputMode } from 'Common/FormEnum';
import { FieldEnum } from 'Common/FieldEnum';
import { ReduxFormButtonGroup } from 'Components/forms/ReduxFormButtonGroup';
import { ChargeDescriptions } from '../helpers/AccountSetupConstants';
import { updateChargePermissions } from '../state/chargeDefaults/actions';
import { resetDirty } from 'State/dirtyTracking/actions';
import { ChargePermissionOptions } from 'Common/Constants/ChargePermissions';

class ChargePermission extends Component {
  alaCarteExpenseOptions = [
    { value: false, label: 'No Restrictions' },
    { value: true, label: 'Not to Exceed' },
  ];

  alaCarteExpFrequencyOptions = [
    { value: 'D', label: 'Day' },
    { value: 'W', label: 'Week' },
    { value: 'M', label: 'Month' },
  ];

  componentDidMount() {
    const { siteId, isNewStudent, dispatch } = this.props;

    if (isNewStudent && siteId.length > 0 && siteId !== 'ALL') {
      dispatch(updateChargePermissions(siteId, null, true));
      dispatch(resetDirty());
    }
  }

  render() {
    const { dispatch, formValues, onSubmit } = this.props;
    const chargeFlag = formValues[FieldEnum.ChargeFlag];

    return (
      <section className="student-form-component grid-spacing">
        <Form onSubmit={onSubmit}>
          <SecurityPreferences scope={PrefEnum.UpdateChargePermissions}>
            {disabled => {
              return (
                <fieldset className="fieldset--clean" disabled={disabled}>
                  <Grid>
                    <Grid.Row>
                      <Grid.Column>
                        <label className="text-orange">Charges</label>
                      </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                      <Grid.Column width={4} verticalAlign={'middle'}>
                        <Field
                          component={SelectField}
                          label={'Charge Status'}
                          name={FieldEnum.ChargeFlag}
                          options={ChargePermissionOptions}
                          disabled={disabled}
                        />
                      </Grid.Column>
                      <Grid.Column width={6} verticalAlign={'bottom'}>
                        {chargeFlag && (
                          <Message compact size={'small'} color={'yellow'}>
                            {ChargeDescriptions[chargeFlag]}
                          </Message>
                        )}
                      </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                      <Grid.Column>
                        <label className="text-orange">
                          A la Carte Purchases
                        </label>
                      </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                      <Grid.Column>
                        <ReduxFormButtonGroup
                          dispatch={dispatch}
                          formName={CHARGE_PERMISSION_FORM_NAME}
                          fieldName={FieldEnum.AlaCarteExpense}
                          value={formValues[FieldEnum.AlaCarteExpense]}
                          options={this.alaCarteExpenseOptions}
                        />
                      </Grid.Column>
                    </Grid.Row>
                    {formValues[FieldEnum.AlaCarteExpense] && (
                      <Grid.Row>
                        <Grid.Column width={3}>
                          <NumericField
                            component={InputField}
                            className="input--currency"
                            icon={<Icon name="dollar" />}
                            iconPosition={'left'}
                            label={'Amount'}
                            name={FieldEnum.AlaCarteAmount}
                            numericSize={[6, 2]}
                            mode={InputMode.Decimal}
                          />
                        </Grid.Column>
                        <Grid.Column
                          width={6}
                          className="input-group--btn-group"
                        >
                          <ReduxFormButtonGroup
                            dispatch={dispatch}
                            formName={CHARGE_PERMISSION_FORM_NAME}
                            fieldName={FieldEnum.AlaCarteExpFrequency}
                            label={'Frequency'}
                            options={this.alaCarteExpFrequencyOptions}
                            value={formValues[FieldEnum.AlaCarteExpFrequency]}
                          />
                        </Grid.Column>
                      </Grid.Row>
                    )}
                  </Grid>
                </fieldset>
              );
            }}
          </SecurityPreferences>
        </Form>
      </section>
    );
  }
}

const mapStateToProps = state => {
  return {
    formValues: getFormValues(CHARGE_PERMISSION_FORM_NAME)(state),
  };
};

ChargePermission = connect(mapStateToProps)(ChargePermission);

const validate = values => {
  const errors = {};

  if (values[FieldEnum.AlaCarteExpense]) {
    if (values[FieldEnum.AlaCarteAmount].length === 0) {
      errors[FieldEnum.AlaCarteAmount] = 'Amount required';
    }

    if (
      !values[FieldEnum.AlaCarteExpFrequency] ||
      values[FieldEnum.AlaCarteExpFrequency].length === 0
    ) {
      errors[FieldEnum.AlaCarteExpFrequency] = 'Frequency required';
    }
  }

  return errors;
};

export default reduxForm({
  validate,
  enableReinitialize: true,
  form: CHARGE_PERMISSION_FORM_NAME,
})(ChargePermission);



// WEBPACK FOOTER //
// ./src/pages/accountsetup/components/ChargePermission.js